// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ic_kos_page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Header ── */
.ic_kos_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-top: 6px;
}

.ic_kos_header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ic_kos_back-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #6b6b6b;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  margin-top: 2px;
}

.ic_kos_back-btn:hover {
  color: #0b0b0b;
}

.ic_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0 0 4px 0;
}

.ic_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Summary Cards ── */
.ic_kos_summary-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.ic_kos_summary-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 20px 24px;
}

.ic_kos_summary-label {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0 0 6px 0;
}

.ic_kos_summary-value {
  font-size: 28px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

/* ── Table Panel ── */
.ic_kos_table-panel {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 20px 0 0 0;
}

.ic_kos_section-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 4px 0;
  padding: 0 20px;
}

.ic_kos_section-sub {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0 0 16px 0;
  padding: 0 20px;
}

/* ── Cell helpers ── */
.ic_kos_vendor {
  color: #6b6b6b;
}

.ic_kos_unit {
  color: #949494;
  font-size: 13px;
}

.ic_kos_instock {
  color: #219647;
}

.ic_kos_cost {
  font-weight: 600;
  color: #0b0b0b;
}

/* ── Qty Control ── */
.ic_kos_qty-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ic_kos_qty-btn {
  width: 26px;
  height: 26px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background: #ffffff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  color: #0b0b0b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ic_kos_qty-btn:hover {
  background: #f0f0f0;
}

.ic_kos_qty-val {
  font-weight: 700;
  font-size: 14px;
  min-width: 24px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/inventory-compute.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".ic_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Header ── */\n.ic_kos_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding-top: 6px;\n}\n\n.ic_kos_header-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ic_kos_back-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #6b6b6b;\n  cursor: pointer;\n  padding: 2px 4px;\n  line-height: 1;\n  margin-top: 2px;\n}\n\n.ic_kos_back-btn:hover {\n  color: #0b0b0b;\n}\n\n.ic_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n}\n\n.ic_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Summary Cards ── */\n.ic_kos_summary-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.ic_kos_summary-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 20px 24px;\n}\n\n.ic_kos_summary-label {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0 0 6px 0;\n}\n\n.ic_kos_summary-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n/* ── Table Panel ── */\n.ic_kos_table-panel {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 20px 0 0 0;\n}\n\n.ic_kos_section-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n  padding: 0 20px;\n}\n\n.ic_kos_section-sub {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0 0 16px 0;\n  padding: 0 20px;\n}\n\n/* ── Cell helpers ── */\n.ic_kos_vendor {\n  color: #6b6b6b;\n}\n\n.ic_kos_unit {\n  color: #949494;\n  font-size: 13px;\n}\n\n.ic_kos_instock {\n  color: #219647;\n}\n\n.ic_kos_cost {\n  font-weight: 600;\n  color: #0b0b0b;\n}\n\n/* ── Qty Control ── */\n.ic_kos_qty-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ic_kos_qty-btn {\n  width: 26px;\n  height: 26px;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  background: #ffffff;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  color: #0b0b0b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ic_kos_qty-btn:hover {\n  background: #f0f0f0;\n}\n\n.ic_kos_qty-val {\n  font-weight: 700;\n  font-size: 14px;\n  min-width: 24px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
